import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import numeral from 'numeral';
import moment from 'moment';
import { Grid, Segment, Icon, Table, Image, Label, Divider, Placeholder, Loader } from 'semantic-ui-react';

import { Compliance } from '../../utils/compliance';

const sf = num => {
  if (num) return (num > 1000 ? numeral(num).format('0.0a') : num);
  return '-';
};
const NUM_COLUMNS = 4;
const NUM_LATEST = 12;
// const INSTAGRAM_POST_URL = 'https://www.instagram.com/p';
const smallMargin = { marginTop: 3 };

const imgStyle = {
  height: '300px',
  minHeight: '300px',
  width: '300px',
  objectFit: 'cover',
  display: 'block',
  margin: '0px auto',
};

const iconStyle = {
  'vertical-align': 'middle',
  display: 'inline',
  height: 35,
};

const ProfileLatestTiktoks = props => {
  const { username, followerCount, posts, statisticsUpdatedDate } = props.tiktokProfileData;

  const latestTiktoks = _.take(posts, NUM_LATEST);
  const chunks = _.chunk(latestTiktoks, NUM_COLUMNS);

  const dataCollectedDate = moment(statisticsUpdatedDate);

  console.log(`TIKTOK USER - ${username}`, followerCount);
  return (
    <Segment padded color="black">
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <h3>
              <Image src="/icons/tiktok.svg" alt="Tiktok" style={iconStyle} /> Latest Tiktok posts&nbsp;
              <span style={{ color: 'grey' }}>(data collected {dataCollectedDate.fromNow()})</span>
            </h3>
            <Divider />
          </Grid.Column>
        </Grid.Row>
        { _.map(chunks, (chunk => <Grid.Row divided columns={NUM_COLUMNS}>
          { _.map(chunk, (post => {
            const { diggCount, commentCount, playCount, text, covers } = post;
            const engagements = diggCount + commentCount;
            const engagementRate = (engagements / followerCount) * 100;
            const isAd = Compliance.isAsaCompliant(text);

            return (<Grid.Column key={post.id}>
              <a
                title="open on Tiktok"
                target="_blank"
                rel="noopener noreferrer"
                href={`https://www.tiktok.com/@${username}/video/${post.id}`}
              >
                {props.tiktokLoading ? (
                  <div style={imgStyle} >
                    <Loader active content="Loading..." />
                  </div>
                ) : (
                  <Image style={imgStyle} src={_.get(covers, 'default')} />
                )}
              </a>
              <Table singleLine style={smallMargin}>
                <Table.Row>
                  <Table.Cell>
                    <Icon name="like outline" /> { sf(diggCount) }
                  </Table.Cell>
                  <Table.Cell>
                    <Icon name="comments outline" /> { sf(commentCount) }
                  </Table.Cell>
                  <Table.Cell>
                    <Icon name="eye" /> { sf(playCount) }
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell colSpan="2">
                    <Icon name="percent" color="pink" /> { numeral(engagementRate).format('0.00') } ENG. RATE
                  </Table.Cell>
                  <Table.Cell style={{ textAlign: 'center' }}>
                    <strong>{ isAd ? <Label color="pink">#AD</Label> : '-'}</strong>
                  </Table.Cell>
                </Table.Row>
              </Table>
            </Grid.Column>);
          }

          )) }
        </Grid.Row>))
        }
      </Grid>
    </Segment>
  );
};


ProfileLatestTiktoks.propTypes = {
  tiktokProfileData: PropTypes.array.isRequired,
  tiktokLoading: PropTypes.bool.isRequired,
};

ProfileLatestTiktoks.defaultProps = {
  tiktokLoading: true,
};


export default ProfileLatestTiktoks;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-latest/profile-latest-tiktoks.js
 **/